var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "21px",
    viewBox: "0 0 30 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3.0 Icon / Rewind") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design---[Web]-Predictor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Predictor-(Mid)-(Signed-Out)-[D]",
    transform: "translate(-121.000000, -1620.000000)",
    fill: "#E32119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video",
    transform: "translate(120.000000, 1502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0-Icon-/-Rewind",
    transform: "translate(0.991892, 113.620277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1154031,12.1842927 C14.1154031,12.8313 13.6696438,13.0772035 13.1228353,12.7354482 L0.992567736,5.154031 C0.444387706,4.81141847 0,5.06320697 0,5.71434798 L0,23.9379671 C0,24.5900342 0.445759253,24.8400394 0.992567736,24.4982841 L13.1228353,16.9168669 C13.6710154,16.5742544 14.1154031,16.8219563 14.1154031,17.4680224 L14.1154031,23.9471286 C14.1154031,24.5941359 14.5644222,24.838002 15.1084625,24.4979768 L29.5903139,15.4468197 C30.1387655,15.1040374 30.1343542,14.5455206 29.5903139,14.2054954 L15.1084625,5.1543383 C14.5600109,4.81155603 14.1154031,5.05912044 14.1154031,5.7051865 L14.1154031,12.1842927 Z",
    id: "Path",
    transform: "translate(15.000000, 14.825640) rotate(180.000000) translate(-15.000000, -14.825640) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewind);
export default __webpack_public_path__ + "static/media/Rewind.ed277664736f96b330bf6d5e119ab35d.svg";
export { ForwardRef as ReactComponent };